import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import {useDispatch} from "react-redux";
import MainLayout from "../../../../commons/layout/MainLayout/index";
import ROUTERS from "../../../../commons/constans/router";
import HeaderHs2 from "../../../../commons/components/Header/headerHs2";
import TextInputComponent from "../../../../commons/components/Forms/TextInputComponent";
import CheckboxComponent from "../../../../commons/components/Forms/CheckboxComponent";
import ButtonComponent from "../../../../commons/components/Forms/ButtonComponent";
import DialogComponent from "../../../../commons/components/Modal/DialogComponent";
import {resetState} from "../../redux/actions";
import {formatSnsType, rememberMeLogin, generateUuid} from "../../../../utils/helpers";

import * as LOGIN_TYPE from './../../redux/actions/type';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    isAndroid,
    isIOS
} from "react-device-detect";
import Loading from "../../../../commons/components/Loading";
import { ReactComponent as LoginApple } from '../../../../assets/images/login_apple.svg'
import { ReactComponent as LoginNaver } from '../../../../assets/images/login_naver.svg'
import { ReactComponent as LoginKakao } from '../../../../assets/images/login_kakao.svg'
import { ReactComponent as LoginGmail } from '../../../../assets/images/login_gmail.svg'

type
Props = {
    loginRequest: Function,
    logOutRequest: Function,
    userInfo: Object,
    isProcessing: Boolean,
    token: String,
    typeRequest: String,
    statusCode: Number,
};


const LoginComponent = ({
                            loginRequest,
                            userInfo,
                            isProcessing,
                            type,
                            loginSnsRequest,
                            errors,
                            token,
                            isProcessingAction
                        }: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [checkLoginSocial, setCheckLoginSocial] = useState(false);
    const [messages, setMessages] = useState("");
    const [errorForm, setErrorForm] = useState({});
    const [snsData, setSnsData] = useState("")

    const [propsButton, setPropsButton] = useState({
        'disableBtn': false,
        'isShowDialog': false,
        'content': ''
    })
    const [dataLogin, setDataLogin] = useState({
        'email': '',
        'password': '',
        'remember_me': true,
        // 'fcm_token': window.fcmToken
    });



    useEffect(() => {
        if (checkLoginSocial) {
            dispatch(resetState());
            let deviceKey = generateUuid();
            //login sns callback
            const snsCallback = (data) => {
                let snsData = JSON.parse(data);
                let snsType = formatSnsType(snsData.snsType);
                
                let param = {
                    sns_type: snsType,
                    sns_id: snsData.snsId,
                    sns_email: snsData.email,
                    sns_phone_number: snsData.phone,
                    sns_nickname: '',
                    sns_fullname: '',
                    sns_avatar: snsData.photoUri,
                    sns_code: '',
                    user_version : window.appDevice?.userVersion || '',
                    device_key :  deviceKey || '',
                    sns_access_token : snsData.accessToken || '',
                    fcm_token : window.appDevice?.fcmToken || '',
                }
                console.log(param, 'param');
                
                dispatch(loginSnsRequest(param));
                setCheckLoginSocial(false)
            }

            window.snsCallback = snsCallback;
        }

        return () => {
            window.snsCallback = null
        }

    },[checkLoginSocial]);

    const textInvalidUserBlocked = () => {
        return <div className="box-error">
            <span className="text-color">해당 계정은 정지된 계정입니다.</span> <br />
            <span>관리자에게 문의 바랍니다.</span> <br />
            <label className="mt-2 phone-contact">
                TEL : 02-2135-5265
            </label>
        </div>
    }

    useEffect(() => {
      let textFailEmailAndPassword =
        '이메일 주소 또는 비밀번호를\n' + '입력해주세요.';
      let textFailNotExistDB = '비밀번호를 확인해주세요';
      let textFailPassword = '이메일을 확인해주세요';
      switch (type) {
        case LOGIN_TYPE.LOGIN_FAILD:
          setErrorForm({});
          // console.log(errors, 'errorserrors LOGIN_FAILD');
          // ko pw, ko email show alert
          if (!dataLogin.email && !dataLogin.password) {
            setPropsButton({
              ...propsButton,
              disableBtn: true,
              isShowDialog: true,
              content: '이메일 주소 또는 비밀번호를\n' + '입력해주세요.',
            });

            return dispatch(resetState());
          }

          if (!dataLogin.email || !dataLogin.password) {
            setPropsButton({
              ...propsButton,
              disableBtn: true,
              isShowDialog: true,
              content: '이메일 주소 또는 비밀번호를\n' + '입력해주세요.',
            });

            return dispatch(resetState());
          }

          if (errors.code === '103' && errors.msg === 'Email is not found') {
            let errors = {
              email: '*이메일을 확인해주세요.',
            };
            setErrorForm(errors);
          } else if (errors.msg && errors.msg === 'unauthentication') {
            let errors = {
              password: '*비밀번호를 확인해주세요.',
            };
            setErrorForm(errors);
          }else if(errors.msg && errors.msg === 'Locked by admin'){
              setPropsButton({
                  ...propsButton,
                  disableBtn: true,
                  isShowDialog: true,
                  content: textInvalidUserBlocked()
              })
          }else{
            setErrorForm(errors);
          }

          // if (errors.msg && errors.msg === 'unauthentication') {
          //     setPropsButton({
          //         ...propsButton,
          //         disableBtn: true,
          //         isShowDialog: true,
          //         content: textFailPassword
          //     })
          // }else if(errors.msg && errors.msg === 'Locked by admin'){
          //     setPropsButton({
          //         ...propsButton,
          //         disableBtn: true,
          //         isShowDialog: true,
          //         content: textInvalidUserBlocked()
          //     })
          // }else if(errors.code === "103" && errors.msg === 'Email is not found') {
          //     setPropsButton({
          //         ...propsButton,
          //         disableBtn: true,
          //         isShowDialog: true,
          //         content: textFailNotExistDB
          //     })
          // }
          // else{
          //     setPropsButton({
          //         ...propsButton,
          //         disableBtn: true,
          //         isShowDialog: true,
          //         content: "errors server"
          //     })
          // }
          dispatch(resetState());
          break;

        case LOGIN_TYPE.LOGIN_SNS_FAILD:
          if (errors.msg && errors.msg === 'Locked by admin') {
            setPropsButton({
              ...propsButton,
              disableBtn: true,
              isShowDialog: true,
              content: textInvalidUserBlocked(),
            });
          } else {
            setPropsButton({
              ...propsButton,
              isShowDialog: true,
              content: '로그인 실패',
            });
          }

          dispatch(resetState());
          break;
        default:
          break;
      }

      // return dispatch(resetState());
    }, [type]);


    const handleChangeCheckBox = (e) => {
        setDataLogin({
            ...dataLogin,
            [e.target.name]: e.target.checked
        })
        console.log(dataLogin);
    }

    const handleChangeIpt = (e) => {
        setDataLogin({
            ...dataLogin,
            [e.target.name]: e.target.value
        })

    }

    const handleSubmitLogin = () => {
        let deviceKey = generateUuid();
        let data = {
            ...dataLogin,
            fcm_token : window.appDevice?.fcmToken || '',
            user_version : window.appDevice?.userVersion || '',
            device_key : deviceKey || '',
        }

        dispatch(loginRequest(data));
    }

    const _handleCloseDialog = () => {
        setPropsButton({
            disableBtn: false,
            isShowDialog: false
        })

    }

    const snsIsProcessing = () => {
        if(isIOS || isAndroid) {
            dispatch(isProcessingAction());
        }
    }

    const _callAppleLogin = () => {
        setCheckLoginSocial(true)
        window.callAppleLogin();
        // snsIsProcessing();
    }

    const _callGoogleLogin = () => {
        setCheckLoginSocial(true)
        window.callGoogleLogin();
        // snsIsProcessing();
    }

    const _callKakaoLogin = () => {
        setCheckLoginSocial(true)
        // let param = {
        //     sns_type:'google',
        //     sns_id:'11789260313350141091966',
        //     sns_email:'ladylikehan@kakao.com',
        //     sns_phone_number: '',
        //     sns_nickname:'Trần Khoa',
        //     sns_fullname:'TrầnKhoa',
        //     sns_avatar:'https://lh3.googleusercontent.com/a-/AOh14GiSST6HQlwMqB_IoWxwznniDBcf19qrrHYqJQ7x\u003ds96-c',
        //     sns_code: '',
        //     sns_access_token: 'eyJhbGciOiJSUzI1NiIsImtpZCI6IjJiMDllNzQ0ZDU4Yzk5NTVkNGYyNDBiNmE5MmY3YjM3ZmVhZDJmZjgiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL2FjY291bnRzLmdvb2dsZS5jb20iLCJhenAiOiIyOTQ3OTM2NjM4MjAtaXA5NDQwZmZxYWdyaGcwM2tjODJucWI3OWpwY202MmIuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJhdWQiOiIyOTQ3OTM2NjM4MjAtN2N0bHNqdTJvbGw2Y3M2M3BxMHZ2NWkwcjByY2ViN2ouYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJzdWIiOiIxMTc4OTI2MDMxMzM1MDE0MTA5MTkiLCJoZCI6ImVuam95d29ya3MuY28ua3IiLCJlbWFpbCI6Imtob2EudHJhbmFuaDkwQGVuam95d29ya3MuY28ua3IiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6IlRy4bqnbiBLaG9hIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hLS9BT2gxNEdpU1NUNkhRbHdNcUJfSW9XeHd6bm5pREJjZjE5cXJySFlxSlE3eD1zOTYtYyIsImdpdmVuX25hbWUiOiJUcuG6p24iLCJmYW1pbHlfbmFtZSI6Iktob2EiLCJsb2NhbGUiOiJlbiIsImlhdCI6MTY1NTY5MDkyMywiZXhwIjoxNjU1Njk0NTIzfQ.axdzq14Aqir1qEqkRq2MP1MqUzzQ-ymaUOx9ss_kuMQ7KYPuzYSHK4xhxQL9jbF4TsWx5YtOIkbjQLAq9qwtUhbWIYxuN2-EPVt6qRiuBtAktb-QSewUylEVpvRKrZ4p46R9W9j0FAS5AxqsZluPYsTMof5UWz3mQ5bIY_rNVze4NY7l_EVr6pt2Dfe1ifsCud84yTOnLTV79yButRNtmsEkIDQnpUWrTcDxrYgUk2koNc8mozz3FIX8OgaI9Q8ihSnLCL_22dwTlQUmwVpLN9BeTFRhcwwdxWGvXuEKV0bJGUMgP4Sz2ivWBXgsdCdzBMORAcrgs6nBfaImCRrCHg',
        //     fcm_token: 'XXXXXXXXXX9823923092',
        //     device_key:'ab68825b09be4c0ce35513dac457b9e263e2e8a80f77b2e789d9329d0975bbd9',
        //     user_version:'0.0',
        // }
        // console.log(param, 'param');
        
        // dispatch(loginSnsRequest(param));
        window.callKakaoLogin();
        // snsIsProcessing();
    }

    const _callNaverLogin = () => {
        setCheckLoginSocial(true)
        window.callNaverLogin();
        // snsIsProcessing();
    }

    return (
        <MainLayout
            isLoading={isProcessing}
            userInfo={userInfo}
            pageID={"login-page"}
            displayBottomNav={false}

        >
            
            <HeaderHs2 title={"로그인"} labelRight={false}/>
            <div className="wrapper">
                {isProcessing ? <Loading/> : ''}
                <div className="container">
                    {snsData}
                    <div className="login-form">
                        <TextInputComponent
                            label={"이메일 주소"}
                            isRequired={false}
                            errorMsg={errorForm?.email || ''}
                            placeHolder={"아이디를 입력해주세요."}
                            id={"id-input"}
                            name={"email"}
                            value={dataLogin.email}
                            handleChange={handleChangeIpt}
                            disabled={isProcessing}
                            readonly={false}
                        />
                        <div className={dataLogin.password ? 'login-page__input-password' : ''}>
                            <TextInputComponent
                                label={"비밀번호"}
                                isRequired={false}
                                errorMsg={errorForm?.password || ''}
                                placeHolder={"영문/숫자 6자~20자 이내"}
                                // id={"id-input"}
                                name={"password"}
                                value={dataLogin.password}
                                type={'text'}
                                handleChange={handleChangeIpt}
                                disabled={isProcessing}
                                readonly={false}
                                appendContent={<span
                                    className={'login-page__input-password__asterisk'}>{Array(dataLogin.password.length).fill('*').join('')}</span>}
                                autoComplete={'off'}
                                maxLength={"20"}
                            />

                            {/*  {showPassword ? formData.password : Array(formData.password.length).fill('*').join('')} */}
                        </div>


                        <CheckboxComponent
                            id={"remember_me"}
                            name={"remember_me"}
                            value={dataLogin.remember_me}
                            handleChange={handleChangeCheckBox}
                            disabled={isProcessing}
                            title={""}
                            subTitle={"자동 로그인"}
                            // image={""}
                            // imageDesc={""}
                            labelClass={`d-flex align-start ${!dataLogin.remember_me ? 'unchecked-remember' : ''}`}
                            checked={dataLogin.remember_me}
                        />

                        <ButtonComponent
                            label={'로그인'}
                            cssClass={"btn btn-block btn-primary login-page__button-login"}
                            type={"button"}
                            loading={true}
                            // disabled={propsButton.disableBtn}
                            disabled={isProcessing}
                            handleClick={handleSubmitLogin}
                        />
                        <div className="forgot-pw">
                            <label
                                onClick={() => {
                                    if(!isProcessing){
                                        navigate(ROUTERS.FORGOT_PW)
                                    }}}
                            >
                                아이디 · 비밀번호 찾기
                            </label>
                            <label className="seperate"/>
                            <label
                                onClick={() => {
                                    if(!isProcessing){
                                        navigate(ROUTERS.REGISTER)
                                    }}}
                            >
                                회원가입
                            </label>
                        </div>
                        <div className="login-social">
                            <div className="login-social__text">
                                <label className="line"/>
                                <label className="text-center">간편 로그인</label>
                                <label className="line"/>
                            </div>
                            <div className="login-social__icon custom-login-social">
                                <div className='content-login-social'>
                                    {isIOS ?
                                        <button
                                            className={'login-page__icon-social-button'}
                                            onClick={_callAppleLogin}
                                            disabled={isProcessing}
                                        >
                                            <LoginApple />
                                        </button>
                                        : ''}

                                    {isIOS || isAndroid ? <>
                                        <button
                                            className={'login-page__icon-social-button'}
                                            disabled={isProcessing}
                                            onClick={_callNaverLogin}
                                        >
                                            <LoginNaver />
                                        </button>
                                        <button
                                            className={'login-page__icon-social-button'}
                                            onClick={_callKakaoLogin}
                                            disabled={isProcessing}
                                        >
                                            <LoginKakao />
                                        </button>
                                        <button
                                            className={'login-page__icon-social-button'}
                                            onClick={_callGoogleLogin}
                                            disabled={isProcessing}
                                        >
                                            <LoginGmail />
                                        </button>
                                    </> :'' }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {propsButton.isShowDialog &&
                <DialogComponent
                    id={"MD3"}
                    show={propsButton.isShowDialog}
                    title={"알림"}
                    closeBtn={"확인"}
                    handleClose={_handleCloseDialog}
                >{propsButton.content}
                </DialogComponent>}
        </MainLayout>
    );
};

export default LoginComponent;
